<template>
  <div class="locations-section container">
    <div class="locations-section__image-wrap">
      <img
        srcset="/static/images/flags@2x.png"
        src="/static/images/flags.png"
        class="locations-section__image"
      >
    </div>
    <div class="locations-section__content">
      <h4 class="locations-section__title">Global locations</h4>
      <div class="locations-section__description">
        Headquartered in the United States with physical locations across Asia and Europe. We have feet on the ground to properly and reliably source, produce, inspect, and ship your products virtually anywhere in the world. 
      </div>
      <div class="locations-section__info">
        <earth-icon />
        <span>With your own dedicated rep, our U.S. based customer service makes it easy to conduct business during normal operating hours while helping you move your product ambitions forward.</span>
      </div>
    </div>
  </div>
</template>

<script>
import EarthIcon from 'static/assets/icons/EarthIcon.svg'

export default {
  name: 'ShippingSection',
  components: {
    EarthIcon,
  },
}
</script>

<style lang="sass" scoped>
@import '~styles/shared'

.locations-section
  padding-bottom: 34px
  padding-top: 43px
  padding-bottom: 77px
  overflow: hidden

  @include tablet
    display: flex
    padding-top: 33px
    padding-bottom: 0

  @include widescreen
    max-width: 1128px
    padding-top: 33px
    margin-bottom: -29px
    align-items: center

.locations-section__content
  margin-top: 6px
  padding-left: 8px
  padding-right: 8px

  @include tablet
    margin-top: 34px
    line-height: 32px
    padding-left: 0

  @include widescreen
    margin-left: -19px
    margin-top: -61px

.locations-section__title
  font-size: 28px
  font-weight: 500
  letter-spacing: -.5px
  padding-right: 10px
  color: #1d3763
  margin-bottom: 33px
  line-height: 32px

  @include tablet
    font-size: 35px
    margin-bottom: 24px

  @include widescreen
    margin-bottom: 20px

.locations-section__description
  color: #525f7f
  letter-spacing: .1px
  padding-right: 10px

  @include tablet
    padding-left: 3px
    line-height: 31px
    padding-right: 0

.locations-section__image-wrap
  margin-top: 5px
  width: 329px
  margin-left: auto
  margin-right: auto
  position: relative
  left: -18px

  @include mobile-smaller
    left: 0

  @include tablet
    flex-shrink: 0
    margin-top: 0
    width: 50%
    left: -29px

  @include widescreen
    width: 552px
    margin-right: 73px
    left: 7px

.locations-section__info
  display: flex
  align-items: flex-start
  margin-top: 18px
  font-size: 17px
  line-height: 26px
  letter-spacing: -.1px
  position: relative
  left: 5px
  color: #525f7f

  @include tablet
    margin-top: 12px
    margin-bottom: 60px

  @include widescreen
    margin-top: 22px
    margin-left: 3px

  svg
    width: 47px
    height: 47px
    flex-shrink: 0
    margin-top: 4px
    margin-right: 24px
    position: relative
    left: -4px
</style>



// WEBPACK FOOTER //
// src/LocationsSection.vue